import CustomGlobalConfig from './helpers/CustomGlobalConfig';
import { MetricsClient } from '@ecg-internal/ecg-js-metrics';

let metricsClient: MetricsClient | undefined;

/**
 * Sends the `pageView` custom metric (Datadog `cm.frontend.page_view`), the denominator of the
 * advertising banner metrics (for example slots requested per page view).
 * Called on page load and on every `trackPage`, so it counts the same page views as GA.
 */
const sendCustomPageViewMetric = (): void => {
  if (!metricsClient) {
    const pageViewMetricConfig = new CustomGlobalConfig().getPageViewMetricConfig();
    if (!pageViewMetricConfig.isValidConfig) {
      return;
    }
    metricsClient = new MetricsClient({
      endpointUrl: pageViewMetricConfig.gptBatchMetricsEndpointUrl,
      virtualUrl: pageViewMetricConfig.vurl,
    });
  }
  metricsClient.addMetrics({ pageView: 1 });
};

export default sendCustomPageViewMetric;
